jQuery('.page-customizable-mattresses .combo-visual').hide();
// jQuery('.page-customizable-mattresses-2 .combo-visual').hide();
jQuery('.page-customizable-mattresses .gallery-wrap').show();
jQuery('.page-customizable-mattresses-2 .gallery-wrap').show();

// When user selects from either dropdown
jQuery('.page-customizable-mattresses .first-selector .dropdown-item, .page-customizable-mattresses .second-selector .dropdown-item').on('click', function() {
  jQuery('.page-customizable-mattresses .combo-visual').show();   // Show combo visual with fade
  jQuery('.page-customizable-mattresses .gallery-wrap').hide();  // Hide gallery smoothly
});

jQuery('.page-customizable-mattresses-2 .first-selector .dropdown-item, .page-customizable-mattresses-2 .second-selector .dropdown-item').on('click', function() {
  jQuery('.page-customizable-mattresses-2 .product__images').addClass('sleeper-selected');
  // jQuery('.page-customizable-mattresses-2 .combo-visual').show();   // Show combo visual with fade
  // jQuery('.page-customizable-mattresses-2 .product_gallery').hide();  // Hide gallery smoothly
});
jQuery('.page-customizable-mattresses-2 .product-gallery__thumbnail').on('click', function() {
  jQuery('.page-customizable-mattresses-2 .product__images').removeClass('sleeper-selected');
});

// (function () {
//   // Mobile only
//   if (window.innerWidth > 441) return;

//   // Page restriction
//   if (!document.body.classList.contains('page-customizable-mattresses-2')) return;

//   function applyOffset() {
//     var iframe = document.querySelector('iframe[title="chat widget"]');
//     if (iframe) {
//       iframe.style.bottom = '95px';
//     }
//   }

//   // Initial attempt
//   applyOffset();

//   // Observe DOM changes caused by Tawk open/close
//   var observer = new MutationObserver(function () {
//     applyOffset();
//   });

//   observer.observe(document.body, {
//     childList: true,
//     subtree: true
//   });
// })();

jQuery(document).ready(function(){
  jQuery('.product-gallery__video video').each(function() {
    var $video = jQuery(this);

    // Ensure muted for autoplay
    $video.prop('muted', true);
    $video.prop('loop', true);

    // Try playing the video
    $video[0].play().catch(function() {
      console.log('Autoplay blocked');
    });

    // Extra safety: restart video if it ends (some Shopify JS may override loop)
    $video.on('ended', function() {
      this.currentTime = 0;
      this.play();
    });
  });
});
